import {Component} from '@angular/core';
import {AgRendererComponent} from 'ag-grid-angular';

@Component({
  selector: 'app-cell-renderer-delete',
  templateUrl: './cell-renderer-delete.component.html',
  styleUrls: ['./cell-renderer-delete.component.less']
})

export class CellRendererDeleteComponent implements AgRendererComponent {

  constructor() { }

  agInit() {

  }

  refresh() {
    return true;
  }

}
